import { render, staticRenderFns } from "./DashboardGenericChartView.vue?vue&type=template&id=3b88bcd0&scoped=true&"
import script from "./DashboardGenericChartView.vue?vue&type=script&lang=js&"
export * from "./DashboardGenericChartView.vue?vue&type=script&lang=js&"
import style0 from "./DashboardGenericChartView.vue?vue&type=style&index=0&id=3b88bcd0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b88bcd0",
  null
  
)

/* custom blocks */
import block0 from "./DashboardGenericChartView.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports